import { useCallback, useEffect, useState } from 'react';

const useSharesLedgerValidation = ({ tableCount, onValidated }: {
  tableCount: number;
  onValidated: () => void;
}) => {
  const [doFullValidation, setDoFullValidation] = useState(false);
  const [completedTables, setCompletedTables] = useState(0);
  const requestValidation = () => {
    if (doFullValidation) return;
    setCompletedTables(0);
    setDoFullValidation(true);
  };
  const updateValidationStatus = useCallback((validationStatus: boolean) => {
    if (!validationStatus) setCompletedTables(count => count + 1);
  }, []);

  // Every mounted ledger must finish before reading its validity state.
  // Counting completions also survives begin/end updates batched by React.
  useEffect(() => {
    if (doFullValidation && completedTables === tableCount) {
      onValidated();
      setDoFullValidation(false);
    }
  }, [completedTables, doFullValidation, onValidated, tableCount]);

  return { doFullValidation, requestValidation, updateValidationStatus };
};

export default useSharesLedgerValidation;
